import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorsService } from '../../../../../../services/errors.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import { PostmanService  } from '../../../../../../services/postman.service';
import moment from 'moment';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent {
  errorId: string;
  errorDetails: any;
  currentBearerToken: string = '';

  public loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private errorsService: ErrorsService,
    private helpersService: HelpersService,
    private router: Router,
    private postmanService: PostmanService
  ) {}

  ngOnInit(): void {
    this.errorId = this.route.snapshot.paramMap.get('id');

    console.log(this.errorId);

    this.getErrorLog();
  }

  getErrorLog() {
    this.loading = true;
    this.errorsService
      .getErrorLog(this.errorId)
      .subscribe(
        (result: any) => {
          console.log(result);

          this.errorDetails = result;
          this.currentBearerToken = this.helpersService.getAuthDataNew() ? this.helpersService.getAuthDataNew().token : '';

          this.errorDetails.createdOn = moment(this.errorDetails.createdOn).format("YYYY-MM-DD HH:mm");

          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.error('Error fetching error details', err);
        },
      );
  }

  goBack(){
    this.router.navigate(['/administration/errors']);
  }
  
  downloadPostmanCURL() {
    this.postmanService.downloadCurlCommand(this.errorDetails, 
      (this.errorDetails.bearerToken == null ? this.currentBearerToken : this.errorDetails.bearerToken)
    );
  }

  copyPostmanCURL() {
    this.postmanService.copyCurlCommandToClipboard(this.errorDetails, 
      (this.errorDetails.bearerToken == null ? this.currentBearerToken : this.errorDetails.bearerToken)
    );
  }
}
